const labels = {
  All: { 'See the offering': 'Katso tarjous' },
  FacilityDetails: { 'Ref: Page title': 'Laitteiden tiedot', 'Ref: Review': 'Arvostelu' },
  FacilitiesList: { 'Ref: Page title': 'Tilat', 'Ref: See details': 'Katso yksityiskohdat' },
};
export default labels;
